import { registerPlugin } from '@capacitor/core';
const Alipay = registerPlugin('Alipay', {
    web: () => import('./web').then(m => new m.AlipayWeb()),
});
export * from './definitions';
export { Alipay };
//# sourceMappingURL=index.js.map